var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_10457_3233)","key":0},React.createElement("path",{"d":"M32.5 16.4204C32.5 7.58385 25.3366 0.42041 16.5 0.42041C7.66344 0.42041 0.5 7.58385 0.5 16.4204C0.5 24.4063 6.35094 31.0257 14 32.226V21.0454H9.9375V16.4204H14V12.8954C14 8.88541 16.3888 6.67041 20.0434 6.67041C21.7934 6.67041 23.625 6.98291 23.625 6.98291V10.9204H21.6075C19.62 10.9204 19 12.1538 19 13.4204V16.4204H23.4375L22.7281 21.0454H19V32.226C26.6491 31.0257 32.5 24.4063 32.5 16.4204Z","fill":"#777777"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_10457_3233"},React.createElement("rect",{"width":"32","height":"32","fill":"white","transform":"translate(0.5 0.42041)"})))]);
}

Facebook.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
